import * as React from 'react';
import { useModal } from '../../hooks/useModal.js';
export var ModalsContainer = function (_a) {
    var open = _a.open, close = _a.close, children = _a.children;
    useModal(open);
    return (React.createElement("div", { className: "modal", onClick: close }, children));
};
//# sourceMappingURL=ModalsContainer.js.map